import React from "react";
import { Route, Switch } from 'react-router-dom';
import AdPage from "./AdPage";
import AdsList from "./AdsList";
import AdsReport from "./AdsReport";

const Ads = props => {
  return (
    <Switch>
      <Route exact path="/ads" component={AdsList} />
      <Route exact path="/ads/new" component={AdPage} />
      <Route exact path="/ads/reports" component={AdsReport} />
      <Route exact path="/ads/:id" component={AdPage} />
    </Switch>
  )
}


export default Ads;